import request from "@/utils/request";

//专家评审设置课题分组分页列表
export const getExpertReviewList = (data) => {
  return request({
    url: "/api/eduExpertsSubjectSettings/list",
    method: "post",
    data
  });
};

//添加基本设置信息
export const addReviewBaseInfo = (data) => {
  return request({
    url: "/api/eduExpertsSubjectSettings/saveBasicInfo",
    method: "post",
    data,
  });
};

//专家评审设置-重新回到第一步修改基本信息
export const editBaseInfoAgain = (data) => {
  return request({
    url: "/api/eduExpertsSubjectSettings/updateBasicInfoOne",
    method: "post",
    data,
  });
};

// 根据评审ID获取基本信息
export const getReviewBaseInfoById = (id) => {
  return request({
    url: "/api/eduExpertsSubjectSettings/basicList/"+id,
    method: "get",
  });
};

//专家评审设置课题分组分页列表
export const getSubjectGroupList = (params) => {
  return request({
    url: "/eduExpertsSubjectGroup/getPageList",
    method: "post",
    data: params,
  });
};
//添加专家评审设置课题分组
export const subjectGroupAdd = (params) => {
  return request({
    url: "/eduExpertsSubjectGroup/add",
    method: "post",
    data: params,
  });
};
//修改专家评审设置课题分组
export const subjectGroupUpdate = (params) => {
  return request({
    url: "/eduExpertsSubjectGroup/update",
    method: "post",
    data: params,
  });
};
//删除专家评审设置课题分组
export const subjectGroupDel = (id) => {
  return request({
    url: `/eduExpertsSubjectGroup/delete/${id}`,
    method: "post",
  });
};
// ---------------------------------------------------
//专家评审设置课题分组内容分页列表
export const getSubjectGroupInfoList = (params) => {
  return request({
    url: "/eduExpertsSubjectGroupInfo/getPageList",
    method: "post",
    data: params,
  });
};
//添加专家评审设置课题分组内容
export const subjectGroupInfoAdd = (params) => {
  return request({
    url: "/eduExpertsSubjectGroupInfo/add",
    method: "post",
    data: params,
  });
};
//修改专家评审设置课题分组内容
export const subjectGroupInfoUpdate = (params) => {
  return request({
    url: "/eduExpertsSubjectGroupInfo/update",
    method: "post",
    data: params,
  });
};
//删除专家评审设置课题分组内容
export const subjectGroupInfoDel = (id) => {
  return request({
    url: `/eduExpertsSubjectGroupInfo/delete/${id}`,
    method: "post",
  });
};

// 课题分组-获取的课题列表
export const getTopicList = (data) => {
  return request({
    url: `/api/eduSubjectDeclare/auditList`,
    method: "post",
		data
  });
};

// 课题分组-删除课题分组
export const delTopicGroupById = (id) => {
  return request({
    url: `/api/eduExpertsSubjectSettings/delGroupInfo/${id}`,
    method: "delete"
  });
};

// 课题分组-删除课题分组中的课题
export const delTopicInGroupByIds = (data) => {
  return request({
    url: `/api/eduExpertsSubjectSettings/moveSubjectDeclare`,
    method: "post",
		data
  });
};




// 根据评审设置ID获取课题分组
export const getTopicGroupByReviewId = (id) => {
  return request({
    url: '/api/eduExpertsSubjectSettings/groupList/'+id,
    method: "get",
  });
};

// 完成课题分组阶段
export const submitTopicGroup = (data) => {
  return request({
    url: '/api/eduExpertsSubjectSettings/saveGroup',
    method: "post",
		data
  });
};

// 分配专家步骤-根据评审ID获取分组列表信息

export const getGroupListByReviewId = (id) => {
  return request({
    url: '/api/eduExpertsSubjectSettings/groupList/'+id,
    method: "get",
  });
};
//分配专家步骤-分配专家
export const allocationExpert = (data) => {
  return request({
    url: '/api/eduExpertsSubjectSettings/expertAllocation',
    method: "post",
		data
  });
};
// 设置评分标准步骤
export const getScoreStandardList = (id) => {
  return request({
    url: '/api/eduExpertsSubjectSettings/scoringCriteriaList/'+id,
    method: "get",
  });
};
// 保存设置评分标准

export const saveScoreStandard = (data) => {
  return request({
    url: '/api/eduExpertsSubjectSettings/saveScoringCriteria',
    method: "post",
		data
  });
};

// 通过评审标准ID删除,评审标准
export const delScoreStandardById = (id) => {
  return request({
    url: '/api/eduExpertsSubjectSettings/delScoringCriteria/'+id,
    method: "delete",
  });
};

// 通过ID查看评审进度
export const getReviewProgress = (data) => {
  return request({
    url: '/api/eduExpertsSubjectSettings/reviewProgressList',
    method: "post",
		data
  });
};

// 通过评审ID查询评审结果
export const getReviewResult = (data) => {
  return request({
    url: '/api/eduExpertsSubjectSettings/reviewResultList',
    method: "post",
		data
  });
};

// 通过评审ID和课题ID获取课题评审结果详情
export const getTopicReviewResultDetailById = (params) => {
  return request({
    url: `/api/eduExpertsSubjectSettings/expertEvaluationDeclareInfo/${params.groupId}/${params.declareId}`,
    method: "get",
  });
};


// 评审结果-晋级按钮功能
export const topicPromotion = (data) => {
  return request({
    url: '/api/eduExpertsSubjectSettings/promotion',
    method: "post",
		data
  });
};

// 提交评审结果
export const submitReviewResult = (data) => {
  return request({
    url: '/api/eduExpertsSubjectSettings/submitReview',
    method: "post",
		data
  });
};

// 通过评审ID删除评审
export const delReviewById = (id) => {
  return request({
    url: '/api/eduExpertsSubjectSettings/del/'+id,
    method: "delete",
  });
};

//上传评分标准附件
export const uploadScoringCriteriaAnnex = (groupId, annexId) => {
  return request({
    url:'/api/eduExpertsSubjectSettings/uploadScoringCriteriaAnnex/'+groupId+'/'+annexId,
    method:'get'
  });
}

//
export const cancelScoringCriteria = (userId, groupId) =>{
  debugger
  return request({
    url : '/api/eduExpertsSubjectSettings/cancelScoringCriteria/'+userId+'/'+groupId,
    method:'get'
  })
}

export const uploadToLocal = (data)=>{
  return request({
    url : '/upload/uploadToLocal',
    method:'post',
    data
  })
}

//文件下载
export const downloadFile = (data) =>{
  return request({
    url:'/upload/download',
    method:'get',
    data
  })


}
